import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from './components/confirmation-modal.component';
import { ChatComponent } from './components/chat.component';
import { ChatMessagesComponent } from './components/chat-messages.component';
import { HonourBoardMessageComponent } from './components/honour-board-message.component';
import { SharedModule } from '../shared/shared.module';
import { ChatFavouritesComponent } from './components/chat-favourites.component';
import { IBQueuedCallsMessageComponent } from './components/ibqueued-calls-message.component';
import { IBQueueHandledMessageComponent } from './components/ibqueue-handled-message.component';
import { ChatPinnedMessageComponent } from './components/chat-pinned-message.component';
import { AuthModule } from '../auth';
import { ChatUserListComponent } from './components/chat-user-list.component';

@NgModule({
  declarations: [
    ChatComponent,
    ChatMessagesComponent,
    HonourBoardMessageComponent,
    ChatFavouritesComponent,
    IBQueuedCallsMessageComponent,
    IBQueueHandledMessageComponent,
    ChatPinnedMessageComponent,
    ConfirmationModalComponent,
    ChatUserListComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    SharedModule,
    NgSelectModule,
    NgbModule,
    AuthModule,
  ],
  exports: [ChatComponent],
})
export class ChatModule {}
